'use strict';

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

function IconArrowTiny(props) {
    return (React__namespace.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 12 12", width: "1em", height: "1em" }, props),
        React__namespace.createElement("defs", null,
            React__namespace.createElement("path", { id: "IconArrowTiny__a", d: "M5 11a.997.997 0 01-.707-.293l-4-4A.983.983 0 010 6.003v-.006a.988.988 0 01.293-.704l4-4a.999.999 0 111.414 1.414L3.414 5H11a1 1 0 110 2H3.414l2.293 2.293A.999.999 0 015 11" })),
        React__namespace.createElement("use", { xlinkHref: "#IconArrowTiny__a", fillRule: "evenodd" })));
}

module.exports = IconArrowTiny;
